var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "srchInput"
  }, [_c('input', {
    ref: "inputSrch",
    attrs: {
      "type": "text",
      "placeholder": "재료명을 입력하세요."
    },
    domProps: {
      "value": _vm.srchStr
    },
    on: {
      "keyup": _vm.keyupHandler
    }
  }), _c('button', {
    staticClass: "addBtn",
    class: _vm.activeClass,
    on: {
      "click": _vm.clickHandler
    }
  }, [_vm._v("재료 추가하기")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }